import { status, StatusType } from '../../typeStatus'

export const GET_TAXES = 'GET_TAXES'
export const GET_TAXES_SUCCEEDED = 'GET_TAXES_SUCCEEDED'
export const GET_TAXES_ERROR = 'GET_TAXES_ERROR'

export const InitialState: TaxesState = {
  taxes: null,
  taxesStatus: status.initial,
}

export interface Taxes {
  id: number
  country_id: number
  tax: number
}

export interface TaxesState {
  taxes: Taxes | null
  taxesStatus: StatusType
}

export interface GetTaxes {
  type: typeof GET_TAXES
  payload: null
}

export interface GetTaxesSucceeded {
  type: typeof GET_TAXES_SUCCEEDED
  payload: Taxes
}

export interface GetTaxesError {
  type: typeof GET_TAXES_ERROR
  payload: null
}

export type TaxesActions = GetTaxes | GetTaxesSucceeded | GetTaxesError
